/**
 * <youtube-facade> custom element.
 *
 * Renders as a click-to-play poster. On user activation it swaps in an
 * iframe pointing at www.youtube-nocookie.com (YouTube's privacy-enhanced
 * embed domain). Until the user clicks, no requests are made to YouTube
 * and no YouTube cookies are set.
 *
 * See snippets/youtube-facade.liquid for the markup that this element
 * expects, and _notes/cookie-consent-remediation-2026-05.md for context.
 */
(function () {
  if (window.customElements && window.customElements.get("youtube-facade"))
    return;

  function buildEmbedUrl(videoId, params) {
    var base =
      "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(videoId);
    var search = new URLSearchParams(params || "");
    if (!search.has("autoplay")) search.set("autoplay", "1");
    if (!search.has("rel")) search.set("rel", "0");
    if (!search.has("modestbranding")) search.set("modestbranding", "1");
    if (!search.has("playsinline")) search.set("playsinline", "1");
    var qs = search.toString();
    return qs ? base + "?" + qs : base;
  }

  class YouTubeFacade extends HTMLElement {
    connectedCallback() {
      if (this.__bound) return;
      this.__bound = true;
      var button = this.querySelector(".youtube-facade__poster");
      if (!button) return;
      button.addEventListener("click", this.activate.bind(this), {
        once: true,
      });
    }

    activate() {
      var videoId = this.dataset.videoId;
      if (!videoId) return;
      var iframe = document.createElement("iframe");
      iframe.src = buildEmbedUrl(videoId, this.dataset.params || "");
      iframe.title = this.dataset.title || "YouTube video player";
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("loading", "eager");
      this.innerHTML = "";
      this.appendChild(iframe);
    }
  }

  window.customElements.define("youtube-facade", YouTubeFacade);
})();
